import React from 'react';
import classnames from 'classnames';
import { Pane, Label, TextInput, Checkbox } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import Model from "../model/BucketAggTextViewModel.js";
import S from '../Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.BucketAggTextViewEditor');
export default function BucketAggTextViewEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const hLFont = ModelEditorFactory.create(Model.getHeaderLabelFont(value), {
    eventData: 'setHeaderLabelFont',
    onChange: onModelChange
  });
  const vLFont = ModelEditorFactory.create(Model.getValueLabelFont(value), {
    eventData: 'setValueLabelFont',
    onChange: onModelChange
  });
  const vTFont = ModelEditorFactory.create(Model.getValueTextFont(value), {
    eventData: 'setValueTextFont',
    onChange: onModelChange
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: classnames(S.grid, S.sub),
    children: [/*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('header')
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: "label",
      children: t('label')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: "label",
      eventData: "setHeaderLabel",
      onChange: onModelChange,
      value: Model.getHeaderLabel(value)
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: "variant",
      children: t('variant')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: "variant",
      eventData: "setVariant",
      onChange: onModelChange,
      value: Model.getVariant(value)
    }), hLFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: hLFont
    }), /*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: "Value"
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill),
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: "Show All Enum Values",
        value: Model.getShowAllEnumValues(value),
        eventData: "setShowAllEnumValues",
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(Label, {
      children: t('label')
    }), vLFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: vLFont
    }), /*#__PURE__*/_jsx(Label, {
      children: t('text')
    }), vTFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: vTFont
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: "trueValue",
      children: t('trueValue')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: "trueValue",
      eventData: "setTrueValue",
      onChange: onModelChange,
      value: Model.getTrueValue(value)
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: "falseValue",
      children: t('falseValue')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: "falseValue",
      eventData: "setFalseValue",
      onChange: onModelChange,
      value: Model.getFalseValue(value)
    })]
  });
}